import { useContext, createContext } from 'react';

import type { AnalyticsMap } from '@widget/utils/getAnalyticsFields';
import type { WidgetStateMachine } from './useWidget';
import type { StepProps } from './useStepForm';

type LayoutSettings = {
  hideHeaderText: boolean;
  setHideHeaderText: (val: boolean) => void;
};

export type WidgetContextValue = WidgetStateMachine & { steps: StepProps[] } & {
  layoutSettings?: LayoutSettings;
  allStepsPreviewMode?: boolean;
  analyticsMap?: AnalyticsMap;
  maxNumberOfSteps: number;
};

export const WidgetContext = createContext<WidgetContextValue | null>(null);

export const useWidgetContext = (): WidgetContextValue => {
  const context = useContext(WidgetContext);

  if (!context) throw new Error('useWidgetContext is used outside of WidgetContext.Provider');

  return context;
};
